import { defineStore } from 'pinia'
import { useSet } from '../useSet'
import { usePredicates } from '../usePredicates'


export const useMyNewsStore = defineStore('myNews', () => {

  const { taskPanelPredicates } = usePredicates()

  return useSet({
    setType: 'my',
    predicates: taskPanelPredicates.my,
  })
})
